import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';

@Component({
  selector: 'app-cadastro-programa',
  templateUrl: './cadastro-programa.component.html',
  styleUrls: ['./cadastro-programa.component.scss']
})
export class CadastroProgramaComponent implements OnInit {

  public arrayTriagem: [];
  query: string;

  constructor(
    private router: Router,
    public util: UtilService,
    private ajax: AjaxService
    
  ) { }

  ngOnInit() {
    
  }

  voltar(){
    this.router.navigate(['/lista-programa']);
  }

  salvar(){

  }

}
